export default "__VITE_ASSET__e43b09d3__"